module.exports = __webpack_public_path__ + "static/media/YM14_0.8125ffac.jpg";